export const LAYOUT_CONFIG = {
		ROW_HEIGHT: 10,
		COLS: {lg: 36, sm: 24, xxs: 12},
		BREAKPOINT: {lg: 1200, sm: 768, xxs: 0},
		ROW_HEIGHT_UNIT: 1 // = LAYOUT_CONFIG.ROW_HEIGHT
}

export const LAYOUT = {
	APPBAR :{
		HEIGHT: 60
	},
	FOOTER :{
    HEIGHT: 35
  },
	SIDEBAR_MENU :{ 
		WIDTH: 70,
		DRAWER_WIDTH: 240
	},
	CHANNEL: { 
		WIDTH: 300,
		HEIGHT: 430,
	}

}